import { ReactNode, useState } from "react";
import { LMSSidebar } from "./LMSSidebar";
import { Button } from "@jambushrushti/components/ui/button";
import { Menu, Bell, Home } from "lucide-react";
import { Link } from "react-router-dom";

interface LMSLayoutProps {
  children: ReactNode;
  title?: string;
}

export function LMSLayout({ children, title }: LMSLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen" style={{ backgroundColor: "#FAF7F2" }}>
      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <LMSSidebar />
      </div>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="animate-fade-in absolute left-0 top-0 h-full w-72">
            <LMSSidebar onClose={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex min-h-screen w-full flex-1 flex-col">
        {/* Top Header */}
        <header
          className="sticky top-0 z-40 border-b"
          style={{ backgroundColor: "#FAF7F2", borderColor: "#E8E4DD" }}
        >
          <div className="flex h-14 items-center justify-between px-3 sm:h-16 sm:px-4 lg:px-6">
            <div className="flex items-center gap-2 sm:gap-4">
              <Button
                variant="ghost"
                size="icon"
                className="h-9 w-9 lg:hidden"
                onClick={() => setSidebarOpen(true)}
              >
                <Menu className="h-5 w-5" />
              </Button>
              {title && (
                <h1 className="font-heading truncate text-base font-semibold text-primary sm:text-xl">
                  {title}
                </h1>
              )}
            </div>

            <div className="flex items-center gap-2 sm:gap-3">
              {/* Home Link */}
              <Button variant="ghost" size="icon" className="h-9 w-9" asChild>
                <Link to="/">
                  <Home className="h-5 w-5" />
                </Link>
              </Button>

              {/* Notifications */}
              <Button variant="ghost" size="icon" className="relative h-9 w-9">
                <Bell className="h-5 w-5" />
                <span className="bg-orange absolute right-1 top-1 h-2 w-2 rounded-full" />
              </Button>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-auto p-3 sm:p-4 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
